import React, { useState, useEffect, useRef, useMemo } from "react";
import { Box, Stack, Card } from "@mui/material";
import { getAbnormalReport } from "./model";
import TextMAS from "components/TextMAS/TextMAS";
import useSnackbarMAS from "utils/useSnackbarMAS/useSnackbarMAS";
import { useAuth } from "utils/useAuth/useAuth";
import s from "./InternalReports.module.scss";
import DefaultData from "./components/DefaultDataTable";
import moment from "moment";
import AbnormalPaymentData from "./components/AbnormalPaymentData";
import NoResult from "components/Datatable/NoResult/NoResult";
import Spin from "components/Spin/Spin";
import { trimObject } from "utils/utils";
import { searchErrorHandler } from "utils/formValidation";
import { useTranslation } from "react-i18next";
import Pagination from "components/Datatable/Pagination/Pagination";

const PAGE_LOCALE_KEY = "page.internalReports.internalReports.";

const InternalReports = (props) => {
  const { t } = useTranslation();
  const { path } = props;
  const { logout } = useAuth();
  const { snackbarError, snackbar } = useSnackbarMAS();
  const service = path.split("/").pop();
  const [reportData, setReportData] = useState(null);
  const [lastModifiedDateTime, setLastModifiedDateTime] = useState("");
  const [searchFieldInput, setSearchFieldInput] = useState({
    startTime: null,
    endTime: null,
  });
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(20);
  const [listTotal, setListTotal] = useState(0);
  const pageSizeInfoRef = useRef({ currentpage: 0, pagesize: 20 });
  const [isLoading, setIsLoading] = useState(true);
  const [searching, setSearching] = useState(false);
  /*
  const [focus, setFocus] = useState({});
  const [error, setError] = useState({
    startTime: false,
    endTime: false,
    startDateLaterThanEndDate: false,
  });
*/
  const pagination = useMemo(() => {
    return {
      currentPage: currentPage,
      pageSize: pageSize,
      pageSizeOptions: [20, 50, 100],
    };
  }, [currentPage, pageSize]);

  /*
  const resetInputField = () => {
    setSearchFieldInput({
      startTime: null,
      endTime: null,
    });
  };

  const resetError = () => {
    setError({
      startTime: false,
      endTime: false,
      startDateLaterThanEndDate: false,
    });
  };

  const handleReset = async () => {
    resetInputField();
    resetError();
    await fetchReport();
  };
*/
  const handleSearch = async (action) => {
    if (action === "search") {
      const { hasError } = searchErrorHandler(searchFieldInput, [
        (input) =>
          ((input.startTime && !input.endTime) || input.endTime === "") && {
            endTime: true,
          },
        (input) =>
          ((input.endTime && !input.startTime) || input.startTime === "") && {
            startTime: true,
          },
        (input) =>
          moment(input.startTime).isAfter(input.endTime) && {
            startDateLaterThanEndDate: true,
          },
      ]);

      // setError(errorObj);
      if (hasError) return;

      setCurrentPage(0);
      pageSizeInfoRef.current.currentpage = 0;
    }
    setSearching(true);
    const params = trimObject({ ...searchFieldInput });
    const payload = {
      page: pageSizeInfoRef.current.currentpage,
      size: pageSizeInfoRef.current.pagesize,
      ...params,
    };
    const result = await getAbnormalReport({
      service: service.replaceAll("-", "_"),
      ...payload,
    });

    if (result?.data?.statusCode === 401) {
      return logout("TOKEN_EXPIRED");
    }

    console.log("result?.data:", result?.data);

    switch (result?.data?.responseCode) {
      case "0000":
        setReportData(result?.data?.data);
        setCurrentPage(result?.data.page);
        setPageSize(result?.data.size);
        setListTotal(result?.data.total);
        setLastModifiedDateTime(result?.data.lastModifiedDateTime);
        pageSizeInfoRef.current.currentpage = result?.data.page;
        pageSizeInfoRef.current.pagesize = result?.data.size;
        break;
      case "2408":
        snackbar({
          message: t("general.message.no.result"),
          variant: "warning",
        });
        break;
      default:
        snackbarError({ message: t("general.message.search.error") });
        break;
    }

    setSearching(false);
  };

  /*
  const textInputOnFocus = (field) => {
    setFocus({ [field]: true });
  };

  const textInputOnBlur = (field, callback) => {
    if (searchFieldInput[field] && callback) {
      const isValidValue = callback(searchFieldInput[field]);
      if (!isValidValue) {
        setError({ ...error, [field]: error });
      }
    }
    setFocus({ [field]: false });
  };

  const searchDateOnChange = (e, type) => {
    const rawDate = JSON.parse(JSON.stringify(e));
    const date = moment(rawDate).isValid()
      ? moment(rawDate).format("YYYY-MM-DD")
      : e !== null
        ? ""
        : null;
    if (type === "start") {
      setError({
        ...error,
        startTime: false,
        startDateLaterThanEndDate: false,
      });
      setSearchFieldInput({ ...searchFieldInput, startTime: date });
    } else if (type === "end") {
      setError({
        ...error,
        endTime: false,
        startDateLaterThanEndDate: false,
      });
      setSearchFieldInput({ ...searchFieldInput, endTime: date });
    }
  };

  const dateFormatValidator = (dateValue) => {
    const isValidDateFormat = moment(dateValue).isValid();
    return isValidDateFormat;
  };
*/
  /*
  const SearchBox = () => {
    return (
      <div className={s.searchFieldContainer}>
        <div className={s.searchBox}>
          <Datepicker
            label={"Start Date"}
            type="start"
            value={searchFieldInput.startTime}
            limitValue={searchFieldInput.endTime}
            onchangeFn={searchDateOnChange}
            onfocusFn={() => textInputOnFocus("startTime")}
            onblurFn={() => textInputOnBlur("startTime", dateFormatValidator)}
            sxParams={{
              datepickerFocus: focus.startTime,
              datepickerError:
                error.startTime || error.startDateLaterThanEndDate,
            }}
          />
          <Datepicker
            label={"End Date"}
            type="end"
            value={searchFieldInput.endTime}
            limitValue={searchFieldInput.startTime}
            onchangeFn={searchDateOnChange}
            onfocusFn={() => textInputOnFocus("endTime")}
            onblurFn={() => textInputOnBlur("endTime", dateFormatValidator)}
            sxParams={{
              datepickerFocus: focus.endTime,
              datepickerError: error.endTime || error.startDateLaterThanEndDate,
            }}
          />
        </div>

        <div id={s.searchButton}>
          <SearchFieldButtonBar
            loading={searching}
            searchBtn
            resetBtn
            handleSearch={handleSearch}
            handleReset={handleReset}
          />
        </div>

        <Divider margin={32} />
      </div>
    );
  };
  */

  const renderReport = () => {
    switch (service) {
      case "abnormal-offline-payment":
      case "abnormal-online-order":
        return <AbnormalPaymentData records={reportData} />;
      default:
        return <DefaultData records={reportData} />;
    }
  };

  const renderReportBody = () => {
    return (
      <div>
        <Stack
          direction={"column"}
          spacing={5}
          className={s.internalReportStack}
        >
          <Box display="flex" justifyContent="flex-end">
            <TextMAS
              text={`Last Modified Date: ${moment(lastModifiedDateTime).format(
                "YYYY/MM/DD HH:MM:ss",
              )}`}
            />
          </Box>

          <Box display="flex" justifyContent={"center"} className={s.reportBox}>
            <Card sx={{ width: "100%", backgroundColor: "white" }}>
              {renderReport()}
            </Card>
          </Box>
        </Stack>

        <Pagination
          pagination={pagination}
          total={listTotal}
          handleSearch={handleSearch}
          setCurrentPage={(e) => {
            setCurrentPage(e);
            console.log("cringe", e);
          }}
          setPageSize={setPageSize}
          pageSizeInfoRef={pageSizeInfoRef}
        />
      </div>
    );
  };

  const fetchReport = async () => {
    const initTime = moment();
    const endTime = initTime.toISOString(true);
    const startTime = initTime.subtract(3, "M").toISOString(true);

    setSearchFieldInput({
      endTime: endTime,
      startTime: startTime,
    });

    let response;
    switch (service) {
      case "abnormal-offline-payment":
      case "abnormal-online-order":
        response = await getAbnormalReport({
          service: service.replaceAll("-", "_"),
          startTime: startTime,
          endTime: endTime,
          page: pageSizeInfoRef.current.currentpage,
          size: pageSizeInfoRef.current.pagesize,
        });
        break;
      case "abnormal-agent-name":
      case "abnormal-br-number":
      case "abnormal-create-date":
      case "abnormal-merchant-legal-name":
      case "abnormal-order-trans-time":
      case "abnormal-settlement-merchant-mdr":
        response = await getAbnormalReport({
          service: service.replaceAll("-", "_"),
          page: pageSizeInfoRef.current.currentpage,
          size: pageSizeInfoRef.current.pagesize,
        });
        break;
      default:
        return null;
    }

    setIsLoading(false);
    console.log("response: ", response);

    if (response?.statusCode === 401) {
      return logout("TOKEN_EXPIRED");
    }

    console.log("response?.data:", response?.data);

    switch (response?.data?.responseCode) {
      case "0000":
        setReportData(response?.data?.data);
        setLastModifiedDateTime(response?.data?.lastModifiedDateTime);
        setCurrentPage(response?.data.page);
        setPageSize(response?.data.size);
        setListTotal(response?.data.total);
        pageSizeInfoRef.current.currentpage = response?.data.page;
        pageSizeInfoRef.current.pagesize = response?.data.size;
        break;
      case "2408":
        snackbar({
          message: t("general.message.no.result"),
          variant: "warning",
        });
        break;
      default:
        snackbar({
          message: t(PAGE_LOCALE_KEY + "fetchingError"),
        });
        break;
    }
  };

  useEffect(() => {
    fetchReport();
  }, [service]);

  return (
    <div className={s.outerContainer}>
      <div className={s.innerContainer}>
        {isLoading ? (
          <div className={s.spinContainer}>
            <Spin />
          </div>
        ) : !reportData || reportData?.length === 0 ? (
          <div className={s.noResultContainer}>
            <NoResult />
          </div>
        ) : (
          renderReportBody()
        )}

        {searching && <Spin type={"search"} />}
      </div>
    </div>
  );
};

export default React.memo(InternalReports);
